import React from "react";

const YouTubeEmbed = ({ url }) => {
  if (!url) return null;

  // ✅ แปลงทุกแบบของลิงก์ให้เหลือเฉพาะ video ID
  const getVideoId = (url) => {
    try {
      const shortRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/;
      const watchRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/;
      const shareRegex = /(?:https?:\/\/)?(?:youtu\.be)\/([a-zA-Z0-9_-]+)/;

      let match =
        url.match(shortRegex) ||
        url.match(watchRegex) ||
        url.match(shareRegex);

      return match ? match[1] : null;
    } catch {
      return null;
    }
  };

  const videoId = getVideoId(url);

  if (!videoId) {
    return (
      <div className="text-red-500 text-sm font-medium mt-2">
        ⚠ Invalid YouTube URL
      </div>
    );
  }

  return (
    <div className="w-full mt-4">
      <iframe
        width="100%"
        height="250"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="rounded-xl"
      ></iframe>
    </div>
  );
};

export default YouTubeEmbed;
